import { render } from "./Notes7.vue?vue&type=template&id=75c267b6&scoped=true"
import script from "./Notes7.vue?vue&type=script&lang=js"
export * from "./Notes7.vue?vue&type=script&lang=js"

import "./Notes7.vue?vue&type=style&index=0&id=75c267b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c267b6"]])

export default __exports__